
<style lang="less">
@import './mobileHeaderMenu.less';
</style>
<template>
    <div class="mobile-header-menu-wrapper" :style="getBackground">
        <div class="header-menu-list" :class="show ? 'menu-list-drop': ''">
            <div class="mobile-menu-content clearfix" :style="getMenuWidth">
                <div class="mobile-header-menu-item" 
                    v-for="(it, index) in menus" 
                    :key="index" 
                    @click="changeMenu(it)" 
                    :style="fontStyle">
                    <span>{{it.name}}</span>
                </div>
            </div>
        </div>
        <div class="mobile-header-menu-drop" @click="changeDrop">
            <svg t="1585341101988" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3727" width="32" height="32"><path d="M216.128 338.112a32 32 0 0 0-45.248 45.312l320 320a32 32 0 0 0 45.248 0l320-320a32 32 0 0 0-45.248-45.312L513.536 635.52 216.128 338.112z" p-id="3728" fill="#ffffff"></path></svg>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        menus: {
            type: Array,
            default: ()=>{
                // item { name: '', link: '' }
                return []
            }
        },
        backColor: {
            type: String,
            default: ''
        },
        fontObj: {
            type: Object,
            default: ()=>{
                return {
                    fontSize: 16,
                    fontStyle: "normal",
                    color: "#E6F2FF",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            }
        }
    },
    data(){
        return {
            show: false
        }
    },
    computed: {
        getMenuWidth(){
            const color = `background:${this.backColor}`;
            return !this.show ? `width:${this.menus.length * 80}px;${color}` : color;
        },
        getBackground(){
            return `background:${this.backColor}`;
        },
        fontStyle(){
            const {fontSize,fontStyle,fontFamily,fontWeight,color} = this.fontObj;
            return `font-size:${fontSize}px;font-style:${fontStyle};font-family:${fontFamily};font-weight:${fontWeight};color:${color}`;
        }
    },
    methods: {
        changeMenu(it,index){
            if(it.link){
                window.location.href = it.link;
            }else{
                this.$emit('mobile-menu-click',{
                    index: index,
                    value: it.name
                })
            }
        },
        changeDrop(){
            this.show = !this.show;
        }
    }
}
</script>
